import { Flex } from '../UI/Flex/Flex';
import * as style from './ChatMessage.module.less';

import { ChatMessageData } from '@assets/model/RagAPI';
import { useStore } from '@assets/model/Store';
import classNames from 'classnames';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';
import { LogoBird } from '../Header/Logo';
import { Button } from 'react-bootstrap';

interface ChatMessageApproveRejectProps {
    onApprove: (didApprove: boolean) => void;
    isLoading?: boolean;
}

export const ChatMessageApproveReject = observer(
    (p: ChatMessageApproveRejectProps) => {
        const contentRef = useRef<HTMLDivElement>(null);
        const clssses = classNames(style.chatmessage, 'fade-in');

        return (
            <>
                <Flex className={clssses} direction="row">
                    <div className="p-3" style={{ height: '50px' }}>
                        <LogoBird />
                    </div>
                    <div
                        ref={contentRef}
                        className="flex-grow-1 p-4 align-self-center"
                        style={{ marginLeft: '0px' }}
                    >
                        <Button
                            style={{
                                filter: 'saturate(0.85)'
                            }}
                            variant="success"
                            className="me-3"
                            disabled={p.isLoading}
                            onClick={() => {
                                p.onApprove(true);
                            }}
                        >
                            Proceed
                        </Button>
                        {/* <Button
                            variant="danger"
                            onClick={() => {
                                p.onApprove(false);
                            }}
                        >
                            Reject
                        </Button> */}
                    </div>
                </Flex>
                {/* {files_references} */}
            </>
        );
    }
);
